import { postToast, ToastType } from "core/src/slices/ui/useCases/postToast/postToast.use-case";
import { createAppAsyncThunk } from "core/src/store/store.types";
import { EtlApiTarget } from "etl/types";

export type TriggerUploadS3BucketRequest = {
	type: "csv" | "file" | "uploaded";
	triggerFilters?: string[]
}

export const triggerUploadS3Bucket = createAppAsyncThunk<void, TriggerUploadS3BucketRequest>(
	"formState/triggerUploadS3Bucket",
	async ({ type, triggerFilters }, { rejectWithValue, getState, extra, dispatch }) => {
		const { selectedEtlImportUuid } = getState().etlData;

		if (!selectedEtlImportUuid) return rejectWithValue("Aucun import sélectionné");

		try {
			if (type === "csv") {
				await extra.etlClient.trigger(EtlApiTarget.UPLOAD_CSV_TO_S3_BUCKET_API, selectedEtlImportUuid, { triggerFilters });

				dispatch(postToast({
					type: ToastType.SUCCESS,
					message: "Fichiers CSV uploadés sur le cloud avec succès"
				}))
			}

			if (type === "file") {
				await extra.etlClient.trigger(EtlApiTarget.UPLOAD_FILE_TO_S3_BUCKET_API, selectedEtlImportUuid, { triggerFilters });

				dispatch(postToast({
					type: ToastType.SUCCESS,
					message: "Fichiers PDF en cours d'upload sur le cloud en tâche de fond"
				}));
			}

			if (type === "uploaded") {
				await extra.etlClient.trigger(EtlApiTarget.UPLOAD_ORIGINAL_FILE_TO_S3_BUCKET_API, selectedEtlImportUuid, { triggerFilters });

				dispatch(postToast({
					type: ToastType.SUCCESS,
					message: "Fichiers d'upload en cours d'upload sur le cloud en tâche de fond"
				}));
			}
		} catch (error) {
			dispatch(postToast({
				type: ToastType.ERROR,
				message: "Erreur lors de l'upload des fichiers"
			}));
			return rejectWithValue(error)
		}
	}
);
